import {
  Create,
  Box,
  TextField,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
} from "@pankod/refine-mui";
import { Controller, useForm } from "@pankod/refine-react-hook-form";

import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = Yup.object({
  tier_name: Yup.string().label("Tier name").required(),
  user_id: Yup.number().label("User Id").required(),
  duration: Yup.number().label("Duration").required(),
});

interface formDataType {
  tier_name: string;
  user_id: number;
  duration: number;
}

export const TierSubscriptionCreate = () => {
  const {
    saveButtonProps,
    refineCore: { formLoading },
    register,
    control,
    formState: { errors },
  } = useForm<formDataType>({ resolver: yupResolver(schema) });

  return (
    <Create isLoading={formLoading} saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("tier_name", {
            required: "This field is required",
          })}
          required
          error={!!(errors as any)?.tier_name}
          helperText={(errors as any)?.tier_name?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Tier_name"
          name="tier_name"
        />
        <TextField
          {...register("user_id")}
          required
          error={!!(errors as any)?.user_id}
          helperText={(errors as any)?.user_id?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          label="user_id"
          name="user_id"
        />
        <TextField
          {...register("duration")}
          required
          error={!!(errors as any)?.duration}
          helperText={(errors as any)?.duration?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          label="Duration"
          name="duration"
        />
      </Box>
    </Create>
  );
};
